import React, { useEffect, useRef, useState } from "react";
import "./HeroSection.css";
import {
  heroimage,
  imageline,
  mapimage,
  curveimage,
  leftarrow,
  mapicon,
} from "../../assets/Exportimageicon";
import Footer from "../../Components/footer/Footer";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const navigate = useNavigate();

  const [cmsData, setCmsData] = useState(null);
  const [cmsLoading, setCmsLoading] = useState(false);

  const [featuredChallenges, setFeaturedChallenges] = useState([]);
  const [challengeLoading, setChallengeLoading] = useState(false);

  const handleVideoToggle = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const getDashboardCms = async () => {
    try {
      setCmsLoading(true);

      const res = await service.get(endpoints.cms.dashboardCms);

      setCmsData(res?.data?.data || null);
    } catch (error) {
      console.log("CMS ERROR", error);
    } finally {
      setCmsLoading(false);
    }
  };

  const getFeaturedChallenges = async () => {
    try {
      setChallengeLoading(true);

      const res = await service.get(
        endpoints.challenges.missionManagementChallenges,
      );
      const challengeData = res?.data?.data?.data || [];

      const publishedChallenges = challengeData.filter(
        (challenge) => challenge?.status?.toLowerCase() !== "draft",
      );

      setFeaturedChallenges(publishedChallenges.slice(0, 8));
    } catch (error) {
      console.log("FEATURED CHALLENGES ERROR", error);
    } finally {
      setChallengeLoading(false);
    }
  };

  useEffect(() => {
    getFeaturedChallenges();
    getDashboardCms();
  }, []);

  return (
    <>
      <div
        className="hero-container"
        style={{
          backgroundImage: `url(${
            cmsData?.heroSection?.backgroundImage || ""
          })`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay"></div>
        <div className="hero-content">
          <div className="hero-left">
            <h1>{cmsData?.heroSection?.heading || "Embark Adventure"}</h1>

            <p>{cmsData?.heroSection?.subHeading || "Explore now"}</p>

            <div className="hero-buttons">
              <button className="primary-btn">
                {cmsData?.heroSection?.button1Text || "Start"}
              </button>

              <button
               className="secondary-btn"
              onClick={() => navigate("/challenges")}>
                {cmsData?.heroSection?.button2Text || "Explore"}
              </button>
            </div>
          </div>
          <div className="hero-right">
            <div className="traveler-image">
              <img
                src={cmsData?.heroSection?.characterImage || heroimage}
                alt="traveler"
              />
            </div>
            <img src={imageline} alt="path line" className="line-img" />
            <div className="stats">
              <div>
                <span>DISTANCE</span>
                <h3>{cmsData?.heroSection?.distance || "0 KM"}</h3>
              </div>

              <div>
                <span>MILESTONES</span>
                <h3>{cmsData?.heroSection?.milestones || "0"}</h3>
              </div>

              <div>
                <span>DURATION</span>
                <h3>{cmsData?.heroSection?.duration || "0%"}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="curve-wrapper">
          <img src={curveimage} alt="curve line" className="curve-line" />
        </div>
      </div>

      <div className="how-it-works">
        <div className="container">
          <div className="section-header">
            <h2>{cmsData?.howItWorks?.sectionHeading || "How It Works"}</h2>

            <p>
              {cmsData?.howItWorks?.sectionDescription ||
                "Simple steps to get started"}
            </p>
          </div>
          <div className="steps-grid-horizontal">
            {cmsData?.howItWorks?.cards?.map((step) => (
              <div className="step-card-horizontal" key={step.id}>
                <div
                  style={{ width: "100%", height: "60%", objectFit: "cover" }}
                  className="step-image-horizontal"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src={step?.image || "./how1.svg"}
                    alt={step?.title}
                  />
                </div>

                <h3>{step?.title}</h3>

                <p>{step?.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="featured-challenges">
        <div className="container">
          <div className="section-header">
            <h2>Featured Challenges</h2>

            <p>
             Take on new challenges, enjoy every step of the journey, and discover beautiful landscapes along the way.
            </p>
          </div>

          <div className="challenges-grid">
            {challengeLoading ? (
              <p className="loading-text">Loading challenges...</p>
            ) : featuredChallenges?.length > 0 ? (
              featuredChallenges.map((challenge) => (
                <div
                  className="challenge-card"
                  key={challenge?.id}
                  onClick={() => navigate(`/challenges/view/${challenge?.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="card-image-area">
                    <img
                      src={ 
                        challenge?.thumbnailImage ||
                        "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=500"
                      }
                      alt={challenge?.missionName || "challenge"}
                    />
                  </div>

                  <div className="card-info-box">
                    <div className="info-content">
                      <h3>{challenge?.missionName || "Challenge"}</h3>

                      <div className="distance-row">
                        <img src={mapicon} alt="map icon" />

                        <span>{challenge?.distanceKm || 0} KM</span>
                      </div>
                    </div>

                    <div className="action-arrow">
                      <img src={leftarrow} alt="left arrow" />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="loading-text">No challenges found</p>
            )}
          </div>

          <div
            className="hero-buttons mt-5 mx-auto"
            style={{ width: "fit-content" }}
          >
            <button
              className="primary-btn"
              onClick={() => navigate("/challenges")}
            >
              Explore Challenges
            </button>
          </div>
        </div>
      </div>

      <div className="discover-section">
        <div className="discover-container">
          <h2 className="discover-title">
            {cmsData?.discoverSection?.sectionTitle || "Discover Your Journey"}
          </h2>
          <div className="video-wrapper" onClick={handleVideoToggle}>
            <video
              ref={videoRef}
              className="discover-video"
              poster={
                cmsData?.discoverSection?.backgroundImage ||
                "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200"
              }
              src={
                cmsData?.discoverSection?.videoUrl ||
                "https://www.w3schools.com/html/mov_bbb.mp4"
              }
              loop
              muted
            />

            <div className="video-overlay"></div>
            {!isPlaying && (
              <div className="play-button-container">
                <div className="white-play-card">
                  <svg className="play-icon" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
            )}
          </div>

          <div className="stats-grid">
            <div className="stat-item">
              <h3>{cmsData?.discoverSection?.totalKm || "1200 KM"}</h3>

              <p>TOTAL KM COVERED BY USERS</p>
            </div>

            <div className="stat-item">
              <h3>{cmsData?.discoverSection?.activeUsers || "5000+"}</h3>

              <p>ACTIVE USERS</p>
            </div>

            <div className="stat-item">
              <h3>{cmsData?.discoverSection?.customerSatisfaction || "98%"}</h3>

              <p>CUSTOMER SATISFACTION</p>
            </div>
          </div>
        </div>
      </div>
      <div className="featured-challenges">
        <div className="container">
          <div className="section-header">
            <h2>{cmsData?.attractions?.sectionTitle || "Top Attractions"}</h2>

            <p>
              {cmsData?.attractions?.sectionDescription ||
                "Explore amazing places"}
            </p>
          </div>
          <div className="challenges-grid ">
            {cmsData?.attractions?.items?.map((challenge) => (
              <div className="challenge-card" key={challenge?.id}>
                <div className="card-image-area">
                  <img src={challenge?.image} alt={challenge?.title} />
                </div>

                <div className="card-info-box">
                  <div className="info-content">
                    <h3>{challenge?.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mission-rewards-section">
        <div className="mission-container">
          <div className="top-content-row">
            <div className="text-column">
              <h1 className="mission-title">
                {cmsData?.ctaSection?.heading || "Start Your Adventure"}
              </h1>

              <p className="mission-description">
                {cmsData?.ctaSection?.subHeading || "Explore the world with us"}
              </p>

              <button
                className="mission-btn"
                onClick={() =>
                  cmsData?.ctaSection?.buttonUrl &&
                  window.open(cmsData?.ctaSection?.buttonUrl, "_blank")
                }
              >
                {cmsData?.ctaSection?.buttonText || "Get Started"}
              </button>
            </div>
            <div className="map-column">
              <img
                src={cmsData?.ctaSection?.mapImage || mapimage}
                alt="World Map Tracker"
                className="world-map-img"
              />
            </div>
          </div>
          <div className="bottom-gallery-grid">
            {[
              cmsData?.ctaSection?.bottomImage1,
              cmsData?.ctaSection?.bottomImage2,
              cmsData?.ctaSection?.bottomImage3,
            ]
              .filter(Boolean)
              .map((img, index) => (
                <div className="gallery-item" key={index}>
                  <img src={img} alt={`gallery-${index}`} />
                </div>
              ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default HeroSection;
